import DiamondPayout from "./container";

export default DiamondPayout;
